module.exports = __webpack_public_path__ + "img/WebexToken_4.28101733.png";